"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Card = _interopRequireDefault(require("./Card"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var portalNodes = {};

var ToolTip = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ToolTip, _React$Component);

  var _super = _createSuper(ToolTip);

  function ToolTip() {
    (0, _classCallCheck2["default"])(this, ToolTip);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(ToolTip, [{
    key: "createPortal",
    value: function createPortal() {
      portalNodes[this.props.group] = {
        node: document.createElement("div"),
        timeout: false
      };
      portalNodes[this.props.group].node.className = "ToolTipPortal";
      document.body.appendChild(portalNodes[this.props.group].node);
    }
  }, {
    key: "renderPortal",
    value: function renderPortal(props) {
      if (!portalNodes[this.props.group]) {
        this.createPortal();
      }

      var parent = props.parent,
          other = (0, _objectWithoutProperties2["default"])(props, ["parent"]);
      var parentEl = typeof parent === "string" ? document.querySelector(parent) : parent;

      _reactDom["default"].render( /*#__PURE__*/_react["default"].createElement(_Card["default"], (0, _extends2["default"])({
        parentEl: parentEl
      }, other)), portalNodes[this.props.group].node);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.active) {
        return;
      }

      this.renderPortal(this.props);
    } // Reason: this is a react lifecycle method, we can't rename it.
    // eslint-disable-next-line @typescript-eslint/naming-convention

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this = this;

      if (!portalNodes[this.props.group] && !nextProps.active || !this.props.active && !nextProps.active) {
        return;
      }

      var props = _objectSpread({}, nextProps);

      var newProps = _objectSpread({}, nextProps);

      if (portalNodes[this.props.group] && portalNodes[this.props.group].timeout) {
        clearTimeout(portalNodes[this.props.group].timeout);
      }

      if (this.props.active && !props.active) {
        newProps.active = true;
        portalNodes[this.props.group].timeout = setTimeout(function () {
          props.active = false;

          _this.renderPortal(props);
        }, this.props.tooltipTimeout);
      }

      this.renderPortal(newProps);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (portalNodes[this.props.group]) {
        _reactDom["default"].unmountComponentAtNode(portalNodes[this.props.group].node);

        clearTimeout(portalNodes[this.props.group].timeout);

        try {
          document.body.removeChild(portalNodes[this.props.group].node);
        } catch (e) {
          void 0;
        }

        portalNodes[this.props.group] = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return ToolTip;
}(_react["default"].Component);

exports["default"] = ToolTip;
ToolTip.propTypes = {
  parent: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]).isRequired,
  active: _propTypes["default"].bool,
  group: _propTypes["default"].string,
  tooltipTimeout: _propTypes["default"].number,
  contentWidth: _propTypes["default"].number,
  isManualControl: _propTypes["default"].bool
};
ToolTip.defaultProps = {
  active: false,
  group: "main",
  tooltipTimeout: 500,
  isManualControl: false
};